import React from "react";
import { DatePicker, Space } from 'antd';
import patientImg from "../../assets/Images/welcome-patient.jpg"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths"
const AppointmentSection = (props) => {
    const history = useHistory()
    const { selectedLanguage } = props
    // console.log(selectedLanguage, 'data')
    const onChange = (date, dateString) => {
        // console.log(date, dateString);
    };
    return (
        <div className="cards-main" >
            <div className="card-section-1" data-aos="fade-right"
                data-aos-easing="ease-out-cubic"
                data-aos-delay="100"
                data-aos-offset="0"
                data-aos-duration="1500">
                <div>
                    <div className="appointment-cards-div">
                        <h2 className="form-heading">{selectedLanguage?.txt_make_an_appointment}</h2>
                        <input className="inp" type="text" placeholder={selectedLanguage?.surname_placeholder} name="" id="" />
                        <div className="phone-inp-div">
                            <input type="text" className="inp phone-inp" placeholder={selectedLanguage?.phone_placeholder} />
                            <input type="text" className="inp phone-inp" placeholder={selectedLanguage?.email_placeholder} />
                        </div>
                    </div>
                </div>
                <div className="card-2">
                    <div className="appointment-cards-div">
                        <h2 className="form-heading">{selectedLanguage?.txt_date_and_time_of_appointment}</h2>
                        <Space direction="vertical" size={12}>
                            <DatePicker className="inp date-inp" placeholder={selectedLanguage?.txt_select} onChange={onChange} needConfirm  />
                        </Space>
                        <input type="text" className="inp disabled-inp" disabled />
                        <span className="date-form-bottom-text">{selectedLanguage?.txt_our_Clinic_admin_will_call_you_back_to_confirm}</span>
                    </div>
                </div>
                <div className="card-3">
                    <div className="appointment-cards-div">
                        <h2 className="form-heading">{selectedLanguage?.txt_how_may_we_help}</h2>
                        <textarea className="inp text-area" placeholder={selectedLanguage?.tell_us_about_your_case_placeholder}></textarea>
                        <button className="form-submit-btn">{selectedLanguage?. submit_button}</button>
                    </div>
                </div>
            </div>
            <div className="card-section-2">
                <div className="card-section-2-img-div" data-aos="fade-up"
                    data-aos-easing="ease-out-cubic"
                    data-aos-delay="100"
                    data-aos-offset="0"
                    data-aos-duration="1500">
                    <img src={patientImg} alt="" />
                </div>
                <div className="card-section-2-text-div">
                    <h2 className="card-section-2-heading">{selectedLanguage?.txt_dr_name}</h2>
                    <p>{selectedLanguage?.txt_dr_description}</p>
                    <h2 data-aos="fade"
                        data-aos-easing="ease-out-quart"
                        data-aos-delay="200"
                        data-aos-duration="500" className="card-section-2-text">{selectedLanguage?.txt_we_are_proud_to_give_you_the_smile_of_your_dream}</h2>
                    <button data-aos="fade-up"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1000" className="card-section-2-btn" onClick={() => history?.push(allPaths?.CLINIC)}>{selectedLanguage?.read_more_button}</button>
                </div>
            </div>
        </div>
    )
}
export default AppointmentSection